import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as null | string;

const slice = createSlice({
  name: 'savedCardToken',
  initialState,
  reducers: {
    setSavedCardToken(state, action: PayloadAction<null | string>) {
      return action.payload || initialState;
    },
  },
});

export const { setSavedCardToken } = slice.actions;

export default slice.reducer;
